import { render } from "./aboutUs.vue?vue&type=template&id=610e6548"
const script = {}

import "./aboutUs.vue?vue&type=style&index=0&id=610e6548&scope=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__